import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LensCreatedData1 from "./LensCreatedData1";

const LensCreationTable1 = (props) => {
  const navigate = useNavigate();

  const {
    combinedV,
    sphValue,
    cylValue,
    axisValue,
    addValue,
    fetchLensPowerData,
    GetdataForUpdate,
    setItemMasterRows,
    ItemsArray,
    setItemsArray,
    setLoading,
    TransAccountId,
    isReversed,
  } = props;

  const PositonStatus = {
    position: "sticky",
    top: "0px",
    zIndex: "5",
  };

  // Check if Add is exactly one and is "0" or "0.00"
  const isAddZero =
    addValue &&
    Array.isArray(addValue) &&
    addValue.length === 1 &&
    (addValue[0] === "0.00" || addValue[0] === "0");

  const rows = document.querySelectorAll(".TrLensCreation");
  rows.forEach((row) => {
    row.addEventListener("click", () => {
      rows.forEach((r) => r.classList.remove("focused-row"));
      row.classList.add("focused-row");
    });
  });

  useEffect(() => {
    const handleArrowNavigation = (event) => {
      try {
        const arrowKeys = ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"];
        if (arrowKeys.includes(event.key)) {
          event.preventDefault();
          const inputs = document.querySelectorAll(".tableBox");
          const currentIndex = Array.from(inputs).findIndex(
            (input) => input === document.activeElement
          );
          let newIndex;
          switch (event.key) {
            case "ArrowLeft":
              newIndex = currentIndex > 0 ? currentIndex - 1 : currentIndex;
              break;
            case "ArrowRight":
              newIndex =
                currentIndex < inputs.length - 1
                  ? currentIndex + 1
                  : currentIndex;
              break;
            case "ArrowUp":
              newIndex =
                currentIndex - 7 >= 0 ? currentIndex - 7 : currentIndex;
              break;
            case "ArrowDown":
              newIndex =
                currentIndex + 7 < inputs.length
                  ? currentIndex + 7
                  : currentIndex;
              break;
            default:
              newIndex = currentIndex;
          }
          inputs[newIndex].focus();
        }
      } catch (error) {
        console.log(error);
      }
    };

    return () => {};
  }, []);

  const headerStyle = {
    backgroundColor: "#5e709e",
    fontWeight: "600",
    color: "white",
    textAlign: "center",
  };

  const cellStyle = {
    width: "0%",
    padding: "3px",
    paddingLeft: "10px",
    margin: "2px",
    textAlign :isAddZero ? "center" :""
  };

  const columnRowStyle = {
    justifyContent: "space-evenly",
    backgroundColor: "#dee1e6",
    height: "25px",
  };

  return (
    <div>
      {(() => {
        if (sphValue != null) {
          return (
            <div id="table" style={{ display: "none" }}>
              <div
                className="tableDiv"
                style={{ maxHeight: "83vh", maxWidth: "92.5vw" }}
              >
                <table className="lensPowerTable">
                  <thead style={PositonStatus}>
                    {!isAddZero ? (
                      <tr>
                        <th colSpan="3" className="headerCellStyle" style={headerStyle}>
                          Add 
                        </th>
                        {addValue.map((value4, index4) => (
                          <th
                            key={index4}
                            colSpan="1"
                            className="headerCellStyle"
                            style={headerStyle}
                          >
                            Add {value4}
                          </th>
                        ))}
                      </tr>
                    ) : (
                      <tr>
                        <th colSpan="1" className="headerCellStyle" style={headerStyle}>
                          CYL 
                        </th>
                        { (isReversed ? [...cylValue].reverse() : cylValue).map((value4, index4) => (
                          <th
                            key={index4}
                            colSpan="1"
                            className="headerCellStyle"
                            style={headerStyle}
                          >
                            {value4}
                          </th>
                        ))}
                      </tr>
                    )}

                    <tr style={columnRowStyle}>
                      <React.Fragment className="ButtonStick4">
                        <th  className="headerCellStyle ButtonStick1" style={cellStyle}>
                          SPH
                        </th>
                        {!isAddZero && (
                          <th className="headerCellStyle ButtonStick2" style={cellStyle}>
                            CYL
                          </th>
                        )}
                         {!isAddZero && (
                        <th className="headerCellStyle ButtonStick" style={cellStyle}>
                          Axis
                        </th>
                         )}
                      </React.Fragment>

                      {!isAddZero ? (
                        addValue.map((_, index4) => (
                          <th key={index4} className="headerCellStyle TabWidthMin">
                            Qty
                          </th>
                        ))
                      ) : (
                         (isReversed ? [...cylValue].reverse() : cylValue).map((_, index4) => (
                          <th key={index4} className="headerCellStyle TabWidthMin">
                            Qty
                          </th>
                        ))
                      )}
                    </tr>
                  </thead>

                  <LensCreatedData1
                    combinedV={combinedV}
                    addValue={addValue}
                    fetchLensPowerData={fetchLensPowerData}
                    GetdataForUpdate={GetdataForUpdate}
                    setItemMasterRows={setItemMasterRows}
                    ItemsArray={ItemsArray}
                    setItemsArray={setItemsArray}
                    setLoading={setLoading}
                    axisValue={axisValue}
                    TransAccountId={TransAccountId}
                    isReversed={isReversed}
                    isAddZero={isAddZero} // Pass it to child component too
                    cylValue={cylValue}
                    sphValue={sphValue}
                  />
                </table>
              </div>
            </div>
          );
        } else {
          console.log("not found");
          return null;
        }
      })()}
    </div>
  );
};

export default LensCreationTable1;
